export module MPCScopeDetection {
    export class ScopeDetection {
        public static hasScopes(comparisonPage: boolean, comparisonFlyout: boolean): boolean {
            const PcfScope: NodeListOf<HTMLElement> = document.querySelectorAll(".pcf-scope");
            const PcpScope: NodeListOf<HTMLElement> = document.querySelectorAll(".mpc-scope .grid");

            return comparisonFlyout === PcfScope.length > 0 && comparisonPage === PcpScope.length > 0;
        }
    }
}